import { CalendarDays, Crosshair, ShieldCheck } from "lucide-react";
import { facts } from "../content/siteContent";

const icons = [CalendarDays, Crosshair, ShieldCheck];

export function Facts() {
  return (
    <dl className="facts" aria-label="Στοιχεία συλλόγου">
      {facts.map((fact, index) => {
        const Icon = icons[index];
        return (
          <div className="fact" key={fact.value}>
            <Icon aria-hidden="true" />
            <dt>{fact.label}</dt>
            <dd>{fact.value}</dd>
          </div>
        );
      })}
    </dl>
  );
}
